<template v-cloak>
  <div class="footer" ref="footer" v-show="$route.meta.navShow">
    <mt-tabbar v-model="$store.state.selected">
      <mt-tab-item id="course">
        <img slot="icon" src="https://ali-static-cdn.kuaizaixuetang.com/shop-web/icons/course_1.png" data-id="course" data-st="0">
        选课
      </mt-tab-item>
      <mt-tab-item id="study">
        <img slot="icon" src="https://ali-static-cdn.kuaizaixuetang.com/shop-web/icons/study_0.png" data-id="study" data-st="0">
        我的课程
      </mt-tab-item>
      <mt-tab-item id="home">
        <img slot="icon" src="https://ali-static-cdn.kuaizaixuetang.com/shop-web/icons/home_0.png" data-id="home" data-st="0">
        我的
      </mt-tab-item>
    </mt-tabbar>
  </div>
</template>

<script>
export default {
  name: 'index',
  inject:['reloads'],
  data () {
    return {
      selected: 'course',
      goChange: true
    }
  },
  mounted () {
    var currUrlPath = KZ.GetUrlRelativePath();
    var isRedirect = KZ.getParam('redirect');
    var currUrl = currUrlPath;
    if(isRedirect){
      if(isRedirect == '/study'){
        currUrl = '/study';
      }else if(isRedirect == '/home'){
        currUrl = '/home';
      }
    }
    if (currUrl === '/course') {
      let icons = this.$refs.footer.querySelector('img[data-id="course"]');
      this.initIcon('course');
      icons.setAttribute('data-st', '1');
      icons.setAttribute('src', 'https://ali-static-cdn.kuaizaixuetang.com/shop-web/icons/course_1.png');
      this.$store.commit('newSelected','course');
      //this.selected = 'course'
    }
    if (currUrl === '/study') {
      let icons = this.$refs.footer.querySelector('img[data-id="study"]');
      this.initIcon('study');
      icons.setAttribute('data-st', '1');
      icons.setAttribute('src', 'https://ali-static-cdn.kuaizaixuetang.com/shop-web/icons/study_1.png');
      this.$store.commit('newSelected','study');
    }
    if (currUrl === '/home') {
      let icons = this.$refs.footer.querySelector('img[data-id="home"]');
      this.initIcon('home');
      icons.setAttribute('data-st', '1');
      icons.setAttribute('src', 'https://ali-static-cdn.kuaizaixuetang.com/shop-web/icons/home_1.png');
      //this.selected = 'home'
      if(currUrl === '/home'){
        this.$store.commit('newSelected','home');
      }else if(currUrl === '/login'){
        this.$store.commit('newSelected','login');
      }
    }
    // if(sessionStorage.getItem('footerItem') !='course' && this.selected == 'course' && currUrl != '/course' && currUrl != '/'){
    //   this.selected = sessionStorage.getItem('footerItem');
    //   this.goChange = false;
    // }else{
    //   this.goChange = true;
    // }
  },
  methods: {

  },
  watch: {
    newSelected (newVal, oldVal) {
      var newValBar = newVal;
      if(newVal == 'login'){
        newValBar = 'home';
      }
      let icons = this.$refs.footer.querySelectorAll('img');
      for (let j = 0; j < icons.length; j++) {
        icons[j].setAttribute('data-st', '0');
        icons[j].setAttribute('src', 'https://ali-static-cdn.kuaizaixuetang.com/shop-web/icons/'+icons[j].getAttribute('data-id')+'_0.png');
        if (icons[j].getAttribute('data-id') == newValBar) {
          icons[j].setAttribute('data-st', '1');
          icons[j].setAttribute('src', 'https://ali-static-cdn.kuaizaixuetang.com/shop-web/icons/'+newValBar+'_1.png')
        }
      }
      //if(this.goChange){
      this.$router.push({name: newVal});
      // }else{
      //   this.goChange = true;
      // }
    }
  },
    computed: {
      newSelected () {
        return this.$store.state.selected
      }
    }
}
</script>

<style lang="scss">
.footer {
  .mint-tabbar {
    position: fixed;
    bottom: 0;
    // border-top: 0.026667rem solid #E5E5E5;
    background-color: #fff;
    background-image: linear-gradient(180deg, #E5E5E5, #E5E5E5 50%, transparent 50%);
    background-size: 100% 1px;
  }
  .mint-tab-item {
    color: #999999;
    padding: 0.106667rem 0;
    &.is-selected {
      background-image: linear-gradient(180deg, #E5E5E5, #E5E5E5 50%, transparent 50%);
      background-size: 100% 1px;
      background-repeat: no-repeat;
      background-color: #fff;
      color: #251B18;
    }
    .mint-tab-item-icon {
      width: 0.746667rem;
      height: 0.746667rem;
      >img{
        pointer-events: none; 
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/footer.vue